import React from "react";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <div>
      <section className="hero-section style-five">
        <div className="divider"></div>

        {/* Left Side Image */}
        <div
          className="left-side-image jarallax"
          data-jarallax=""
          data-speed="0.8"
          style={{ backgroundImage: "url('assets/img/bg-img/59.jpg')" }}
        ></div>

        <div className="container">
          <div className="row justify-content-end">
            <div className="col-12 col-md-6">
              {/* Hero Content */}
              <div className="hero-content">
                <div
                  className="mb-3 text-primary h5 fw-semibold wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="500ms"
                >
                  We provide professional Law services
                </div>
                <h2
                  className="mb-4 wow fadeInUp text-white"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  Empowering Your Legal in Success
                </h2>
                <p
                  className="text-white wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="900ms"
                >
                  There are many variations of passages of Ipsum available, but
                  the majority suffered form randomised words injected.
                </p>
                <Link
                  to="/aboutus"
                  className="btn btn-primary wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="1100ms"
                >
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div
          className="svg-shape wow fadeIn"
          data-wow-duration="1000ms"
          data-wow-delay="1500ms"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="255"
            height="255"
            viewBox="0 0 255 255"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M177.421 1.21644C179.043 2.83836 179.043 5.46801 177.421 7.08993L133.369 51.1415L203.852 121.624L247.903 77.5734C249.525 75.9515 252.155 75.9515 253.777 77.5734C255.399 79.1953 255.399 81.825 253.777 83.4469L209.726 127.498L253.78 171.552C255.402 173.174 255.402 175.803 253.78 177.425C252.158 179.047 249.528 179.047 247.906 177.425L203.852 133.371L133.369 203.855L177.424 247.909C179.046 249.531 179.046 252.161 177.424 253.783C175.802 255.405 173.172 255.405 171.55 253.783L127.496 209.728L83.4458 253.778C81.8239 255.4 79.1943 255.4 77.5724 253.778C75.9504 252.156 75.9504 249.527 77.5724 247.905L121.622 203.855L51.1394 133.372L7.08993 177.421C5.46801 179.043 2.83836 179.043 1.21644 177.421C-0.405478 175.799 -0.405481 173.17 1.21644 171.548L45.2659 127.498L1.21915 83.4514C-0.402767 81.8295 -0.402764 79.1999 1.21915 77.578C2.84107 75.956 5.47072 75.956 7.09264 77.578L51.1394 121.625L121.622 51.1415L77.5751 7.09408C75.9532 5.47216 75.9532 2.84251 77.5751 1.22059C79.197 -0.401325 81.8266 -0.401325 83.4486 1.22059L127.496 45.268L171.548 1.21644C173.169 -0.40548 175.799 -0.40548 177.421 1.21644ZM127.496 57.015L57.0129 127.498L127.496 197.981L197.979 127.498L127.496 57.015Z"
              fill="url(#paint0_radial_1_2962)"
            />
            <path
              d="M127.498 59.5C127.498 97.0546 97.0536 127.499 59.499 127.499C97.0536 127.499 127.498 157.943 127.498 195.497C127.498 157.943 157.942 127.499 195.496 127.499C157.942 127.499 127.498 97.0546 127.498 59.5Z"
              fill="url(#paint1_radial_1_2961)"
            />
            <defs>
              <radialGradient
                id="paint0_radial_1_2962"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(127.498 127.5) rotate(90) scale(141.211 141.209)"
              >
                <stop stopColor="white" stopOpacity="0.1" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint1_radial_1_2961"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(127.498 127.499) rotate(90) scale(78.6234)"
              >
                <stop stopColor="white" stopOpacity="0.1" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </radialGradient>
            </defs>
          </svg>
        </div>

        <div
          className="svg-shape second wow fadeIn"
          data-wow-duration="1000ms"
          data-wow-delay="2000ms"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="255"
            height="255"
            viewBox="0 0 255 255"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M177.421 1.21644C179.043 2.83836 179.043 5.46801 177.421 7.08993L133.369 51.1415L203.852 121.624L247.903 77.5734C249.525 75.9515 252.155 75.9515 253.777 77.5734C255.399 79.1953 255.399 81.825 253.777 83.4469L209.726 127.498L253.78 171.552C255.402 173.174 255.402 175.803 253.78 177.425C252.158 179.047 249.528 179.047 247.906 177.425L203.852 133.371L133.369 203.855L177.424 247.909C179.046 249.531 179.046 252.161 177.424 253.783C175.802 255.405 173.172 255.405 171.55 253.783L127.496 209.728L83.4458 253.778C81.8239 255.4 79.1943 255.4 77.5724 253.778C75.9504 252.156 75.9504 249.527 77.5724 247.905L121.622 203.855L51.1394 133.372L7.08993 177.421C5.46801 179.043 2.83836 179.043 1.21644 177.421C-0.405478 175.799 -0.405481 173.17 1.21644 171.548L45.2659 127.498L1.21915 83.4514C-0.402767 81.8295 -0.402764 79.1999 1.21915 77.578C2.84107 75.956 5.47072 75.956 7.09264 77.578L51.1394 121.625L121.622 51.1415L77.5751 7.09408C75.9532 5.47216 75.9532 2.84251 77.5751 1.22059C79.197 -0.401325 81.8266 -0.401325 83.4486 1.22059L127.496 45.268L171.548 1.21644C173.169 -0.40548 175.799 -0.40548 177.421 1.21644ZM127.496 57.015L57.0129 127.498L127.496 197.981L197.979 127.498L127.496 57.015Z"
              fill="url(#paint0_radial_1_2961)"
            />
            <path
              d="M127.498 59.5C127.498 97.0546 97.0536 127.499 59.499 127.499C97.0536 127.499 127.498 157.943 127.498 195.497C127.498 157.943 157.942 127.499 195.496 127.499C157.942 127.499 127.498 97.0546 127.498 59.5Z"
              fill="url(#paint1_radial_1_29611)"
            />
            <defs>
              <radialGradient
                id="paint0_radial_1_2961"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(127.498 127.5) rotate(90) scale(141.211 141.209)"
              >
                <stop stopColor="white" stopOpacity="0.1" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint1_radial_1_29611"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(127.498 127.499) rotate(90) scale(78.6234)"
              >
                <stop stopColor="white" stopOpacity="0.1" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </radialGradient>
            </defs>
          </svg>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default HeroSection;
